import { render, staticRenderFns } from "./Indices.vue?vue&type=template&id=09c7fe2f&scoped=true&"
import script from "./Indices.vue?vue&type=script&lang=js&"
export * from "./Indices.vue?vue&type=script&lang=js&"
import style0 from "./Indices.vue?vue&type=style&index=0&id=09c7fe2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c7fe2f",
  null
  
)

export default component.exports